<template>
  <content-with-sidebar
    class="cws-container cws-sidebar-right blog-wrapper"
  >
    <div class="c-drawer-back">
      <b-button
        variant="primary"
        class="btn-icon"
        @click="handleClose"
      >
        <feather-icon icon="ArrowLeftIcon" />
      </b-button>
      <slot name="drawerTopBtns" />
    </div>
    <div
      class="blog-detail-wrapper"
    >
      <b-row>
        <b-col cols="12">
          <b-card
            style="width: 100%"
            img-top
            img-alt="Blog Detail Pic"
            :title="feedBackInfo.title"
          >
            <b-media no-body>
              <b-media-aside
                vertical-align="center"
                class="mr-50"
              >
                <div class="name-cols">
                  <!-- @click="handleImgClick(feedBackInfo.photo ? feedBackInfo.photo.link : '')" -->
                  <b-avatar
                    :src="feedBackInfo.photo ? feedBackInfo.photo.link : ''"
                  />
                  <!-- <div style="margin-left: 0.5rem;">
                    <p>{{ feedBackInfo.code }}</p>
                    <p>{{ feedBackInfo.name }}</p>
                  </div> -->
                </div>
              </b-media-aside>
              <b-media-body>
                <div>
                  <p style="margin-bottom: 0">
                    {{ feedBackInfo.name }}
                    <span class="text-muted ml-75 mr-50">|</span>
                    <small class="text-muted">{{ feedBackInfo.createTime }}</small>
                  </p>
                  <p style="margin-bottom: 0">
                    {{ userCode(feedBackInfo) }}
                  </p>
                </div>

              </b-media-body>
            </b-media>
            <div
              class="blog-content"
              style="margin-top: 20px"
              v-html="feedBackInfo.topic"
            />
            <template v-if="feedBackInfo.baseTopicAttachs && feedBackInfo.baseTopicAttachs.length">
              <c-upload
                v-model="feedBackInfo.baseTopicAttachs"
                :limit="8"
                :disabled="true"
              />
            </template>
          </b-card>
        </b-col>

        <b-col
          id="blogComment"
          cols="12"
          class="mt-2"
        >
          <h6 class="section-label">
            {{ i18n('feedback.comment') }}
          </h6>

          <b-card
            v-for="(comment,index) in commentList"
            :key="index"
          >
            <b-media no-body>
              <b-media-aside class="mr-75">
                <b-avatar
                  :src="comment.photo ? comment.photo.link : ''"
                  size="38"
                />
              </b-media-aside>
              <b-media-body>
                <div>
                  <p style="margin-bottom: 0">
                    {{ comment.name }}
                    <span class="text-muted ml-75 mr-50">|</span>
                    <small class="text-muted">{{ comment.createTime }}</small>
                  </p>
                  <p style="margin-bottom: 0">
                    {{ userCode(comment) }}
                  </p>
                </div>
                <b-card-text>
                  {{ comment.feedBack }}
                </b-card-text>
                <template v-if="comment.baseTopicAttachs && comment.baseTopicAttachs.length">
                  <c-upload
                    v-model="comment.baseTopicAttachs"
                    :limit="8"
                    :disabled="true"
                  />
                </template>
              </b-media-body>
            </b-media>
          </b-card>
          <c-pagination
            :page="page"
            @change="pageChange"
          />
        </b-col>

        <b-col
          cols="12"
          class="mt-2"
        >
          <h6 class="section-label">
            {{ i18n('feedback.commentTitle') }}
          </h6>
          <b-card>
            <b-overlay
              :show="loading"
              rounded="sm"
            >
              <my-form
                v-if="!loading"
                ref="formRef"
                :data.sync="data"
                :loading="loading"
                :option="option"
                width="auto"
                :footer-visible="false"
              />
              <b-col
                cols="12"
                md="12"
              >
                <c-upload
                  v-if="!loading"
                  v-model="photo"
                  :limit="8"
                  @change="updatePhoto"
                />
              </b-col>
              <b-row>
                <b-col
                  cols="12"
                  class="my-form_btns"
                >
                  <b-button
                    variant="primary"
                    class="mr-3"
                    :disabled="loading"
                    @click="handleSubmit"
                  >
                    {{ i18n('feedback.submit') }}
                  </b-button>
                </b-col>
              </b-row>
            </b-overlay>
          </b-card>
        </b-col>
      </b-row>
    </div>

  </content-with-sidebar>
</template>

<script>
import ContentWithSidebar from '@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue'
import {
  BCard, BRow, BCol, BMediaAside, BMedia, BMediaBody, BButton, BAvatar, BOverlay,
} from 'bootstrap-vue'
import { submitComment, getCommentList } from '@/api/feedBack'
import { deepClone } from '@/util/util'
import MyForm from '@/components/myForm/index.vue';
import { mapGetters } from 'vuex'
import CUpload from '@/components/upload/index.vue';
import eventBus from '@/util/eventBus';
import CPagination from './components/pagination.vue'

export default {
  components: {
    ContentWithSidebar,
    BCard,
    BRow,
    BCol,
    BMediaAside,
    BMedia,
    BMediaBody,
    BButton,
    MyForm,
    CUpload,
    BAvatar,
    BOverlay,
    CPagination,
  },
  data() {
    return {
      feedBackInfo: {},
      commentList: [],
      baseTopic: {},
      data: {},
      loading: false,
      photo: '',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 12,
      },
      currentPage: 0,
      feedBackId: '',

    }
  },
  computed: {
    ...mapGetters(['userAllInfo']),
    option() {
      const columns = [
        {
          label: this.i18n('feedback.comment'),
          field: 'feedBack',
          formOption: {
            type: 'textarea',
          },
        },
      ]
      const option = {
        columns,
      }
      return option
    },
    commentsOps() {
      const columns = [
        {
          label: 'Text',
          field: 'text',
        },
        {
          label: 'File',
          field: 'baseTopicAttachs',
          type: 'upload',
          dictField: 'baseTopicAttachs',
          formOption: {
            span: 12,
            type: 'upload',
            dictField: 'baseTopicAttachs',
          },
        },
      ]
      const option = {
        columns,
      }
      return option
    },
  },
  created() {
    this.feedBackId = this.$route.params.id
    this.currentPage = this.$route.params.page
  },
  mounted() {
    this.onLoad(this.page)
  },
  methods: {
    async onLoad(page) {
      this.loading = true
      // leaverecordAPI
      const res = await getCommentList(page.currentPage, page.pageSize, { topicId: this.feedBackId })
      const { data } = res.data;
      this.page.page = data.baseFeedbackVOIPage.current
      this.page.total = data.baseFeedbackVOIPage.total
      this.commentList = data.baseFeedbackVOIPage && data.baseFeedbackVOIPage.records
      this.feedBackInfo = data.baseTopicVO
      this.loading = false
    },
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    userCode(item) {
      return item.workerCode ? item.workerCode : item.staffCode
    },
    handleClose() {
      // eventBus.$emit('saveCurrentPage', this.currentPage)
      // this.$router.go(-1)
      this.$router.push({ name: 'Feedback', params: { page: this.currentPage } })
    },
    i18n(param) {
      return this.$t(`_feedback.${param}`)
    },
    handleSubmit() {
      this.loading = true
      // baseTopicAttachs
      const params = deepClone(this.data)
      params.topicId = this.feedBackInfo.id
      const userId = this.userAllInfo.id
      params.userId = userId
      this.data = {}
      submitComment(params).then(res => {
        this.loading = false
        this.data = {}
        this.photo = []
        this.$forceUpdate()
        this.onLoad(this.page)
      })
    },
    updatePhoto(e) {
      this.data.fileId = e.map(o => o.attachId).join()
    },
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-blog.scss';

</style>
<style lang="scss" scoped>
.name-cols {
  display: flex;align-items: center;
  p {
    padding: 0;
  }
}
.my-form_btns {
  display: flex;
  justify-content: right;
}
.c-drawer{
    position: absolute !important;
    width: 100%;
    left: 0;
    top: 0;
    &-close{
        display: none;
        z-index: -1;
    }
    &-open{
        display: block;
        z-index: 100;
    }
    &-back,&-title{
      position: absolute;
      top: -50px;
    }
    &-back{
      right: 0;
    }
    &-title{
      right: 50%;
    }
}
</style>
